"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ListDescription = require("./ListDescription");
Object.keys(_ListDescription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ListDescription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListDescription[key];
    }
  });
});